var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fallback"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-title"},[_vm._v("PROJECT42")]),_c('div',{staticClass:"content-subtitle"},[_vm._v("Oops... something wen wrong!")])])])
}]

export { render, staticRenderFns }